import { faker } from '@faker-js/faker'

import { MakeReservationJpSuccessResponse } from '../../contracts/reservation'
import { OrderProgress, OrderProgressState } from '../../contracts/appointment/orderProgress'

export const getReservationKrSuccessResponse = (): OrderProgress => ({
  consultationId: undefined,
  purchaseId: undefined,
  paymentId: undefined,
  reservationId: faker.number.int(),
  progressId: faker.datatype.uuid(),
  state: OrderProgressState.RESERVATION_WAITING,
  serviceOfferId: faker.number.int(),
  isFailure: false,
})

export const getReservationJpSuccessResponse = (): MakeReservationJpSuccessResponse => {
  return {
    consultationId: faker.number.int(),
    createdAt: faker.date.past().toISOString(),
    eventId: faker.number.int(),
    hospitalId: faker.number.int(),
    id: faker.number.int(),
    memberEmail: faker.internet.email(),
    memberId: faker.number.int(),
    memberName: faker.person.fullName(),
    memberPhoneNumber: faker.phone.number(),
    reservedAt: faker.date.future().toISOString(),
    slotId: faker.number.int(),
    state: faker.helpers.arrayElement([
      'NONE',
      'CALLED',
      'RECALL',
      'NOTANSWER',
      'GONE',
      'FIXED',
      'VISITED',
      'VISIT_CANCELED',
      'VISITED_AND_GONE',
      'OPERATED',
      'OPERATION_BOOKED',
      'OPERATION_CANCELED',
      'FINISH',
    ]),
    updateCount: faker.number.int(),
    updatedAt: faker.date.past().toISOString(),
  }
}

export const getTryReservationSuccessResponse = (): { reservationId: number } => {
  return {
    reservationId: faker.number.int(),
  }
}
